import React from 'react'

/**
 * NOTE(중요)
 * - 아래 문구는 “업무용 SaaS”에서 흔히 쓰는 표준 구성(템플릿)입니다.
 * - 업종/과금/전자상거래 해당 여부, 처리 데이터(민감정보 포함 여부), 위탁/국외이전 여부에 따라 필수 조항이 달라집니다.
 * - 실제 운영 전 반드시 법무/정책 검토를 거쳐 서비스 정책에 맞게 수정하세요.
 */

const EFFECTIVE_DATE = '2026-01-12'

const COMPANY = {
  name: '설계 EZ',
  representative: '(대표자명 입력)',
  address: '(주소 입력)',
  bizNo: '(사업자등록번호 입력)',
  contactEmail: '(문의 이메일 입력)',
}

function NoteBox({ children }) {
  return (
    <div className="rounded border bg-slate-50 px-3 py-2 text-xs text-slate-600">
      {children}
    </div>
  )
}

export function TermsContent() {
  return (
    <div className="space-y-4 text-sm leading-relaxed text-slate-800">
      <NoteBox>
        아래 약관은 “표준 구성”을 갖춘 템플릿입니다. 실제 운영(유료 요금제/해지·환불/전자상거래 해당 여부/책임 제한 등)에 맞춰
        문구를 확정해 주세요.
      </NoteBox>

      <h2 className="text-base font-semibold">제1조(목적)</h2>
      <p>
        본 이용약관(이하 “약관”)은 {COMPANY.name}(이하 “회사”)가 제공하는 서비스(이하 “서비스”)의 이용과 관련하여 회사와 이용자(이하
        “회원”) 간의 권리·의무 및 책임사항, 이용조건 및 절차 등 기본사항을 규정함을 목적으로 합니다.
      </p>

      <h2 className="text-base font-semibold">제2조(정의)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>“서비스”란 회사가 제공하는 웹/앱 기반 기능 및 이에 부수하는 제반 서비스를 말합니다.</li>
        <li>“회원”이란 본 약관에 동의하고 회사가 정한 절차에 따라 서비스 이용을 승인받아 계정을 부여받은 자를 말합니다.</li>
        <li>“계정”이란 회원 식별 및 서비스 이용을 위해 회원에게 부여되는 이메일 등 식별정보와 비밀번호 등의 인증수단을 말합니다.</li>
        <li>“콘텐츠”란 회원 또는 회사가 서비스에서 제공·표시·저장·전송하는 정보(텍스트, 이미지, 파일 등 일체)를 말합니다.</li>
      </ul>

      <h2 className="text-base font-semibold">제3조(약관의 효력 및 변경)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>본 약관은 서비스 화면에 게시하거나 기타 방법으로 공지함으로써 효력이 발생합니다.</li>
        <li>
          회사는 관련 법령을 위반하지 않는 범위에서 약관을 변경할 수 있으며, 변경 시 시행일 및 변경사유를 명시하여 사전 공지합니다.
        </li>
        <li>회원이 변경 약관 시행 이후에도 서비스를 계속 이용하는 경우 변경 약관에 동의한 것으로 봅니다.</li>
      </ul>

      <h2 className="text-base font-semibold">제4조(회원가입 및 계정관리)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          회원가입은 이용자가 약관 및 개인정보 처리방침에 동의하고 회사가 정한 절차에 따라 가입(신청/승인 포함)을 완료함으로써
          성립합니다.
        </li>
        <li>회사는 업무상·기술상 필요에 따라 가입 신청을 승인하거나 제한할 수 있습니다.</li>
        <li>회사는 만 14세 미만 아동의 가입 신청을 제한할 수 있습니다.</li>
        <li>회원은 계정 정보(비밀번호 포함)를 안전하게 관리할 책임이 있으며, 타인에게 공유/양도/대여할 수 없습니다.</li>
      </ul>

      <h2 className="text-base font-semibold">제5조(서비스의 제공 및 변경)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>회사는 안정적인 서비스 제공을 위해 서비스의 전부 또는 일부를 변경할 수 있습니다.</li>
        <li>중요한 변경 사항은 서비스 내 공지, 이메일 등 합리적인 방법으로 사전 안내합니다.</li>
      </ul>

      <h2 className="text-base font-semibold">제6조(서비스의 중단)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>회사는 시스템 점검, 장애, 네트워크 문제 등 불가피한 경우 서비스 제공을 일시 중단할 수 있습니다.</li>
        <li>회사는 중단 사유 및 기간을 사전 공지하되, 긴급한 경우 사후 공지할 수 있습니다.</li>
      </ul>

      <h2 className="text-base font-semibold">제7조(회원의 의무 및 금지행위)</h2>
      <p>회원은 서비스 이용 시 관련 법령, 본 약관 및 회사의 운영정책을 준수하여야 하며, 다음 행위를 하여서는 안 됩니다.</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>타인의 계정/개인정보를 도용하거나 허위 정보를 등록하는 행위</li>
        <li>서비스의 정상 운영을 방해하거나 시스템을 침해하려는 행위</li>
        <li>불법·유해 콘텐츠 게시/전송, 권리 침해(저작권/초상권/영업비밀 등) 행위</li>
        <li>회사 또는 제3자를 비방하거나 업무를 방해하는 행위</li>
      </ul>

      <h2 className="text-base font-semibold">제8조(콘텐츠의 권리)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>회원이 서비스에 저장/업로드한 콘텐츠의 권리는 원칙적으로 회원에게 귀속됩니다.</li>
        <li>회사는 서비스 제공을 위해 필요한 범위에서 콘텐츠를 저장·처리·전송할 수 있습니다.</li>
        <li>회사가 제공하는 서비스/소프트웨어/디자인 등 지식재산권은 회사 또는 정당한 권리자에게 귀속됩니다.</li>
      </ul>

      <h2 className="text-base font-semibold">제9조(유료서비스/결제)</h2>
      <p className="text-slate-700">
        회사가 유료서비스를 제공하는 경우, 요금제·결제·해지·환불(해당 시) 조건은 별도 안내(요금제/운영정책) 또는 개별 계약에 따릅니다.
      </p>

      <h2 className="text-base font-semibold">제10조(계약해지 및 이용제한)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>회원은 회사가 정한 방법으로 이용계약 해지를 요청할 수 있습니다.</li>
        <li>회사는 회원이 본 약관을 위반한 경우 경고, 이용정지, 계약해지 등 조치를 할 수 있습니다.</li>
      </ul>

      <h2 className="text-base font-semibold">제11조(손해배상 및 면책)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          회사는 고의 또는 중대한 과실이 없는 한 서비스 장애로 인한 손해에 대해 책임을 부담하지 않습니다(관련 법령이 허용하는 범위 내).
        </li>
        <li>회원의 귀책사유로 발생한 손해에 대해 회사는 책임을 지지 않습니다.</li>
      </ul>

      <h2 className="text-base font-semibold">제12조(분쟁해결 및 관할)</h2>
      <p>
        회사와 회원 간 분쟁이 발생한 경우, 관련 법령에 따라 성실히 협의하여 해결하며, 협의가 어려운 경우 관할 법원은 민사소송법 등
        관련 법령에 따릅니다.
      </p>

      <h2 className="text-base font-semibold">부칙</h2>
      <p>본 약관은 {EFFECTIVE_DATE}부터 시행합니다.</p>
    </div>
  )
}

export function PrivacyContent() {
  return (
    <div className="space-y-4 text-sm leading-relaxed text-slate-800">
      <NoteBox>
        아래 방침은 “표준 구성”을 갖춘 템플릿입니다. 실제 운영(위탁/국외이전/보관기간/처리 항목)에 맞춰 내용을 확정해 주세요.
      </NoteBox>

      <h2 className="text-base font-semibold">1. 개인정보의 처리 목적</h2>
      <p>회사는 다음 목적을 위해 개인정보를 처리합니다.</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>회원가입 신청 처리 및 승인, 계정 발급 및 관리</li>
        <li>서비스 제공, 기능 개선, 고객지원 및 민원 처리</li>
        <li>서비스 안정성 확보(보안, 이상행위 탐지, 로그 분석 등)</li>
        <li>법령상 의무 이행 및 분쟁 대응</li>
      </ul>

      <h2 className="text-base font-semibold">2. 처리하는 개인정보 항목</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          <b>회원가입 신청/계정관리</b>: 이메일(필수), 이름(필수), 비밀번호(필수, 해시로 저장), 휴대폰번호(선택), 소속 조직/역할(필수)
        </li>
        <li>
          <b>서비스 이용 과정에서 자동 생성/수집</b>: 접속 로그, IP, 기기정보(브라우저 User-Agent), 쿠키/세션 식별자, 오류/이벤트 로그
        </li>
        <li>
          <b>선택 동의</b>: 마케팅/광고성 정보 수신 동의 여부 및 동의 이력(버전/시각 등)
        </li>
      </ul>

      <h2 className="text-base font-semibold">3. 개인정보의 보유 및 이용기간</h2>
      <p>
        회사는 원칙적으로 개인정보 처리 목적 달성 시 지체 없이 파기합니다. 다만 서비스 운영 및 보안, 분쟁 대응을 위해 아래 기준에 따라
        일정 기간 보관할 수 있습니다.
      </p>

      <div className="overflow-auto rounded border">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-700">
            <tr>
              <th className="text-left p-2 border-b">구분</th>
              <th className="text-left p-2 border-b">보관 항목(예시)</th>
              <th className="text-left p-2 border-b">보관 기간(기준)</th>
            </tr>
          </thead>
          <tbody className="text-slate-800">
            <tr>
              <td className="p-2 border-b">회원 계정</td>
              <td className="p-2 border-b">이메일, 이름, 비밀번호(해시), 휴대폰(선택), 조직/역할</td>
              <td className="p-2 border-b">회원 자격 유지 기간</td>
            </tr>
            <tr>
              <td className="p-2 border-b">가입 신청</td>
              <td className="p-2 border-b">가입 신청 정보 및 동의 이력(버전/시각/IP/UA 등)</td>
              <td className="p-2 border-b">승인/거절 처리 후 1년(감사/분쟁 대응 목적)</td>
            </tr>
            <tr>
              <td className="p-2 border-b">서비스 이용 로그</td>
              <td className="p-2 border-b">접속기록, 요청 요약(TraceId 등), 오류/이벤트 로그</td>
              <td className="p-2 border-b">일반 로그 30일 / 오류 로그 180일</td>
            </tr>
            <tr>
              <td className="p-2 border-b">첨부파일(의뢰)</td>
              <td className="p-2 border-b">의뢰 첨부 파일(스토리지 저장)</td>
              <td className="p-2 border-b">14일</td>
            </tr>
            <tr>
              <td className="p-2 border-b">첨부파일(공지)</td>
              <td className="p-2 border-b">공지 첨부 파일(스토리지 저장)</td>
              <td className="p-2 border-b">30일</td>
            </tr>
            <tr>
              <td className="p-2 border-b">미참조 파일</td>
              <td className="p-2 border-b">어떤 화면/레코드에도 연결되지 않은 업로드 파일</td>
              <td className="p-2 border-b">3일</td>
            </tr>
            <tr>
              <td className="p-2 border-b">삭제 처리된 파일</td>
              <td className="p-2 border-b">deleted_at이 기록된 파일</td>
              <td className="p-2 border-b">7일(물리 삭제 유예)</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="text-xs text-slate-500">
        위 기간은 운영 기준이며, 관련 법령 또는 개별 계약(조직 단위 계약 등)에 따라 달라질 수 있습니다.
      </p>

      <h2 className="text-base font-semibold">4. 개인정보의 파기절차 및 방법</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>파기 사유가 발생한 개인정보는 내부 방침 및 관련 법령에 따라 지체 없이 파기합니다.</li>
        <li>전자적 파일 형태: 복구 불가능한 방법으로 영구 삭제</li>
        <li>출력물 형태: 분쇄 또는 소각</li>
      </ul>

      <h2 className="text-base font-semibold">5. 개인정보의 제3자 제공</h2>
      <p>회사는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만 법령에 근거하거나 이용자의 동의가 있는 경우 예외로 합니다.</p>

      <h2 className="text-base font-semibold">6. 개인정보 처리의 위탁</h2>
      <p>회사는 원활한 서비스 제공을 위해 개인정보 처리업무를 위탁할 수 있으며, 위탁 시 관련 법령에 따라 수탁자를 관리·감독합니다.</p>
      <div className="overflow-auto rounded border">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-700">
            <tr>
              <th className="text-left p-2 border-b">수탁자</th>
              <th className="text-left p-2 border-b">위탁 업무 내용</th>
              <th className="text-left p-2 border-b">이전/보관</th>
            </tr>
          </thead>
          <tbody className="text-slate-800">
            <tr>
              <td className="p-2 border-b">Amazon Web Services, Inc.</td>
              <td className="p-2 border-b">클라우드 인프라(서버/DB/파일 저장소(S3) 등) 운영</td>
              <td className="p-2 border-b">서비스 제공 기간(리전: ap-northeast-2 등)</td>
            </tr>
            <tr>
              <td className="p-2 border-b">Google LLC (Firebase Cloud Messaging)</td>
              <td className="p-2 border-b">푸시 알림 전송</td>
              <td className="p-2 border-b">서비스 제공 기간</td>
            </tr>
            <tr>
              <td className="p-2 border-b">(주)솔라피(Solapi) 등</td>
              <td className="p-2 border-b">알림톡/문자(SMS) 발송 대행(해당 기능 사용 시)</td>
              <td className="p-2 border-b">발송 처리 목적 달성 시까지</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2 className="text-base font-semibold">6-1. 개인정보의 국외 이전(해당 시)</h2>
      <p>
        회사는 서비스 제공을 위해 국외에 위치한 인프라/사업자를 이용할 수 있습니다. 예를 들어 푸시 알림(FCM)과 같은 글로벌 서비스는
        처리 과정에서 일부 정보가 국외(미국 등)로 이전·처리될 수 있습니다.
      </p>
      <ul className="list-disc pl-5 space-y-1">
        <li>이전 항목(예시): 기기 식별자(푸시 토큰), 알림 메시지 페이로드(최소 정보)</li>
        <li>이전 목적: 푸시 알림 전송</li>
        <li>이전 시점/방법: 알림 발송 시 네트워크를 통한 전송</li>
        <li>보유/이용기간: 서비스 제공 기간 또는 제공자 정책에 따름</li>
      </ul>

      <h2 className="text-base font-semibold">7. 정보주체의 권리·의무 및 행사방법</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>이용자는 개인정보 열람/정정/삭제/처리정지 요구 등 권리를 행사할 수 있습니다.</li>
        <li>권리 행사는 서비스 내 기능 또는 고객센터({COMPANY.contactEmail})를 통해 요청할 수 있습니다.</li>
      </ul>

      <h2 className="text-base font-semibold">8. 개인정보의 안전성 확보조치</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>비밀번호 등 인증정보는 안전한 방식(해시 등)으로 처리</li>
        <li>접근권한 관리, 접근통제, 보안 업데이트, 로그 점검 등</li>
      </ul>

      <h2 className="text-base font-semibold">9. 쿠키의 사용</h2>
      <p>회사는 서비스 제공을 위해 쿠키를 사용할 수 있으며, 이용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있습니다.</p>

      <h2 className="text-base font-semibold">9-1. 마케팅/광고성 정보 수신 동의의 철회</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>이용자는 언제든지 마케팅/광고성 정보 수신 동의를 철회할 수 있습니다.</li>
        <li>철회 방법: 고객센터({COMPANY.contactEmail})로 “수신거부/철회 요청”을 접수</li>
      </ul>

      <h2 className="text-base font-semibold">10. 개인정보 보호책임자</h2>
      <div className="rounded border bg-slate-50 p-3 text-sm">
        <div>상호: {COMPANY.name}</div>
        <div>대표자: {COMPANY.representative}</div>
        <div>주소: {COMPANY.address}</div>
        <div>사업자등록번호: {COMPANY.bizNo}</div>
        <div>문의: {COMPANY.contactEmail}</div>
      </div>

      <h2 className="text-base font-semibold">11. 고지의 의무</h2>
      <p>본 방침의 내용 추가·삭제 및 수정이 있을 경우, 시행일 최소 7일 전(중요 변경은 30일 전)부터 공지합니다.</p>

      <h2 className="text-base font-semibold">부칙</h2>
      <p>본 방침은 {EFFECTIVE_DATE}부터 시행합니다.</p>
    </div>
  )
}

